import Vue from "vue"
Vue.filter("ellipseShorten",function(value, toLength){
    /*
    cannot shorten to a length greater than the length of the passed-in string
     and cannot shorten strings that are 5 chars or less since the ellipsis is
    3 characters and we need to keep one character on each side at least
    */
    if(toLength >= value.length || value.length <= 5 || toLength <= 5){
        return value;
    }
    const charsInEllipse = 3;
    var numOfCharsOnLeft =  Math.ceil((toLength - charsInEllipse) / 2);
    var numOfCharsOnRight =  Math.floor((toLength - charsInEllipse) / 2);
    var leftSide = value.substring(0,numOfCharsOnLeft)
    var rightSide = value.substring(value.length - numOfCharsOnRight, value.length)
    return leftSide + "..." + rightSide;
  });

  Vue.filter("elseShow",function(value, replaceWith){
    if(value){
        return value;
    }
    return replaceWith;
  });
  
  